import React from 'react';
import { Chip, ChipProps } from '@mui/material';
import { marketPlaceStatuses } from '../../utils/variables';

interface MarketplaceStatusChipProps extends Omit<ChipProps, 'color'> {
  status: string;
  size?: 'small' | 'medium';
}

const MarketplaceStatusChip: React.FC<MarketplaceStatusChipProps> = ({
  status,
  size = 'small',
  ...props
}) => {
  const getStatusColor = (status: string): ChipProps['color'] => {
    // Handle both status IDs and status names
    if (
      status === marketPlaceStatuses.Approved ||
      status.toLowerCase() === 'approved'
    ) {
      return 'success';
    }
    if (
      status === marketPlaceStatuses.AwaitingApproval ||
      status.toLowerCase() === 'pending' ||
      status.toLowerCase() === 'awaitingapproval'
    ) {
      return 'warning';
    }
    if (
      status === marketPlaceStatuses.Rejected ||
      status.toLowerCase() === 'rejected'
    ) {
      return 'error';
    }
    if (
      status === marketPlaceStatuses.Expired ||
      status.toLowerCase() === 'expired'
    ) {
      return 'info';
    }
    if (
      status === marketPlaceStatuses.Removed ||
      status.toLowerCase() === 'removed'
    ) {
      return 'default';
    }
    // Fallback for any other status
    return 'default';
  };

  const getStatusLabel = (status: string): string => {
    // Handle both status IDs and status names
    if (
      status === marketPlaceStatuses.Approved ||
      status.toLowerCase() === 'approved'
    ) {
      return 'Approved';
    }
    if (
      status === marketPlaceStatuses.AwaitingApproval ||
      status.toLowerCase() === 'pending' ||
      status.toLowerCase() === 'awaitingapproval'
    ) {
      return 'Awaiting Approval';
    }
    if (
      status === marketPlaceStatuses.Rejected ||
      status.toLowerCase() === 'rejected'
    ) {
      return 'Rejected';
    }
    if (
      status === marketPlaceStatuses.Expired ||
      status.toLowerCase() === 'expired'
    ) {
      return 'Expired';
    }
    if (
      status === marketPlaceStatuses.Removed ||
      status.toLowerCase() === 'removed'
    ) {
      return 'Removed';
    }
    // Fallback for any other status
    return status;
  };

  return (
    <Chip
      label={getStatusLabel(status)}
      color={getStatusColor(status)}
      size={size}
      variant="outlined"
      {...props}
    />
  );
};

export default MarketplaceStatusChip;
